import { createSlice } from '@reduxjs/toolkit';
import { productPropPrecedenceList } from './productPropAsyncThunk';

const productPropPrecedenceListSlice = createSlice({
  name: "productProp",
  initialState: {
    payload: [],
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [productPropPrecedenceList.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [productPropPrecedenceList.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.payload = [...action.payload.list];
    },
    [productPropPrecedenceList.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default productPropPrecedenceListSlice.reducer;